import { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import {
    BoxContainer,
    BoxHead,
    Underline,
} from "../../Components/Styles/PageStyles";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import { capitalizeFirstLetter } from "../../helpers";
import { SummarySkeletonLoading, TenantDetailsLoading } from "../../Components/SkeletonLoading";
import moment from "moment";
import Images from "../../Images";
import StaffDetailModal from "../../Components/AdminStaff/StaffDetailModal";
import DeactivateStaff from "../../Components/AdminStaff/DeactivateStaff";
import StaffDocument from "../../Components/AdminStaff/StaffDocument";
import PayableTable from "../../Components/AdminStaff/PayableTable";
import Loading from "../../Components/Loading";
import SideModal from "../../Components/SideModal";
import MarkAsPaidOfflineModal from "../../Components/Expenses/MarkAsPaidOfflineModal";
import AddPayable from "../../Components/AdminStaff/AddPayable";
import Menu from "../../Components/AdminStaff/Menu";
import SummaryCards from "../../Components/AdminStaff/SummaryCard";
import Table from "../../Components/AdminStaff/LedgerTable";
import { MdKeyboardArrowDown } from "react-icons/md";
import { InputGroup } from "../../Components/Styles/InputStyles";
import DatePicker from "react-datepicker";
import NotFoundModel from "../../Components/NotFoundModel";
import StaffCommission from "./StaffCommission";
import StaffDetailCommission from "../../Components/AdminStaff/StaffDetailCommission";
import { MdAdd } from "react-icons/md";
import CashRecordModal from "../../Components/AdminStaff/CashRecordModal";
import { hasPermission } from "../../helpers";
import { FiArrowLeft } from "react-icons/fi";

const StaffDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const staffDetails = location.state?.staffDetails;
    const user = useSelector((state) => state.UserReducer.user);
    const [activeTab, setActiveTab] = useState("overview");
    const [docs, setDocs] = useState([]);
    const [isDocumentAdd, setIsDocumentAdd] = useState(false);
    const [apiData, setApiData] = useState();
    const [isDeactivateStaff, setIsDeactivateStaff] = useState(false);
    const [isMarkPaidExpense, setIsMarkPaidExpense] = useState(false);
    const [isAddPayable, setIsAddPayable] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [expenseData, setExpenseData] = useState([]);
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [isCashRecord, setIsCashRecord] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const month = moment(selectedDate).month() + 1;
    const year = moment(selectedDate).year();
    const query = `m=${month}&y=${year}`;

    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/staff/summary/${staffDetails?.id}?${query}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            },
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) error = true;
        else {
            setApiData(res?.data);
            setDocs(res?.data?.docs);
        }
    };

    const getError = (res) => { };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        getListMutate();
    }, [selectedDate]);


    //------- Upload Document -------
    const uploadDocumentFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/staff/upload/document`, values, {
            headers: {
                authorization: `Bearer ${user.token}`,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };

    const onUploadDocSuccess = (data) => {
        setIsDocumentAdd(false);
        if (data?.data?.isSuccess === true) {
            setDocs(data?.data?.docs);
            toast.success(data?.data?.msg || "Success");
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onUploadDocError = (data) => {
        setIsDocumentAdd(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: isDocLoading, mutate: uploadDocMutate } = useMutation(
        uploadDocumentFunction,
        {
            onSuccess: onUploadDocSuccess,
            onError: onUploadDocError,
        },
    );

    //------- Edit Staff -------
    const editStaffFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/staff/edit`, values, {
            headers: {
                authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
            },
        });
    };
    const onEditStaffSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            // getListMutate();
        } else {
            toast.error(data?.rdata?.msg || "An Error Occured");
        }
    };

    const onEditStaffError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editStaffLoading, mutate: editStaffMutate } = useMutation(
        editStaffFunction,
        {
            onSuccess: onEditStaffSuccess,
            onError: onEditStaffError,
        }
    );

    //------- Deactivate/Activate Staff -------
    const deactivateStaffFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/staff/toggle/status`, values, {
            headers: {
                authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const onDeactivateStaffSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setIsDeactivateStaff(false);
            getListMutate();
        } else {
            toast.error(data?.rdata?.msg || "An Error Occured");
        }
    };

    const onDeactivateStaffError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: deactivateStaffLoading, mutate: deactivateStaffMutate } =
        useMutation(deactivateStaffFunction, {
            onSuccess: onDeactivateStaffSuccess,
            onError: onDeactivateStaffError,
        });

    // staff Payable Listing
    const fetchListing = async () =>
        await axios.get(`${Config.apiUrl}/staff/list/payables/${staffDetails?.id}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
            },
        });

    const { isLoading: isPayableListingLoading, error: payableListingError, data: payableData, refetch, isRefetching: isPayableListingRefetching } = useQuery(
        ['staffPaybaleData', staffDetails?.id],
        fetchListing,
        {
            enabled: activeTab === "payables",
            onSuccess: () => {
                fetchInitData();
            },
        }

    );

    //------- Mark As Paid Expense -------
    const markPaidExpenseFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/expense/mark/paidx`, values, {
            headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };

    const onMarkPaidExpenseSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            refetch();
            setIsMarkPaidExpense(false);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onMarkPaidExpenseError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: markPaidExpenseLoading, mutate: markPaidExpenseMutate } =
        useMutation(markPaidExpenseFunction, {
            onSuccess: onMarkPaidExpenseSuccess,
            onError: onMarkPaidExpenseError,
        });

    const fetchInitData = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/expense/initial-values`,
            {
                headers: {
                    Authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        setExpenseData(response.data.data);
    };

    //------- Add Payables -------
    const addPayableFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/staff/pay/new`, values, {
            headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const onAddPayableSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            refetch();
            setIsAddPayable(false);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onAddPayableError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addPayableLoading, mutate: addPayableMutate } =
        useMutation(addPayableFunction, {
            onSuccess: onAddPayableSuccess,
            onError: onAddPayableError,
        });
    // staff Ledger Listing
    const fetchLedgerListing = async () =>
        await axios.get(`${Config.apiUrl}/staff/ledger/list/${staffDetails?.id}?pageNum=1`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
            },
        });

    const { isLoading: isLedgerListingLoading, error: ledgerListingError, data: ledgerData, refetch: ledgerRefetch, isRefetching: isLedgerRefetching } = useQuery(
        ['staffledgerData', staffDetails?.id],
        fetchLedgerListing,
        {
            enabled: activeTab === "ledger",
            onSuccess: () => {
                setIsFocused(true);
            },
        }

    );

    const canManagePayables = hasPermission("MANAGE_STAFF_PERMISSION", user);
    const inhandCash = Number(apiData?.summary?.inhand || 0);
    const showFab = canManagePayables && inhandCash > 0;

    //------- Pay To Client (Record Cash) -------
    const payToClientFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/staff/pay-to-client`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const onPayToClientSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Cash recorded successfully");
            setIsCashRecord(false);
            getListMutate(); // refresh summary
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onPayToClientError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: payToClientLoading, mutate: payToClientMutate } =
        useMutation(payToClientFunction, {
            onSuccess: onPayToClientSuccess,
            onError: onPayToClientError,
        });

    return (
        <BoxContainer>
            <button
                type="button"
                onClick={() => navigate(-1)}
                className="flex items-center gap-1.5 mb-4 text-primary-color text-base
        font-normal hover:opacity-80 transition-opacity"
            >
                <FiArrowLeft size={20} />
                Back
            </button>
            {!error && !isLoading && data && (
                <PageWrapper className='mt-2'>
                    <CardContainer>
                        <HeaderWrapper>
                            <ProfileWrapper>
                                <AvatarWrapper>
                                    <UserImage
                                        src={Images.Avatar}
                                        alt={`Staff Profile`}
                                    />
                                </AvatarWrapper>
                                <TenantInfos>
                                    <NameWrapper>
                                        <TenantName>
                                            {capitalizeFirstLetter(apiData?.name)}
                                        </TenantName>
                                    </NameWrapper>
                                    <TenantProp>#{apiData?.mobile}</TenantProp>
                                </TenantInfos>
                            </ProfileWrapper>
                            <ButtonWrapper>
                                <InputGroup>
                                    <div className="relative items-center">
                                        <DatePicker
                                            selected={selectedDate}
                                            onChange={(date) => setSelectedDate(date)}
                                            dateFormat="MMMM yyyy"
                                            showMonthYearPicker
                                            className="border border-gray-400 p-2 rounded-md w-40 h-10 bg-white cursor-pointer pl-8"
                                            maxDate={new Date()}
                                            onFocus={(e) => e.target.blur()}
                                            showFullMonthYearPicker
                                            showTwoColumnMonthYearPicker
                                            onClickOutside={() => setCalendarOpen(false)}
                                            onSelect={() => setCalendarOpen(false)}
                                            open={calendarOpen}
                                            onInputClick={() => setCalendarOpen(true)}
                                            showPopperArrow={false}
                                            portalId="root-portal"
                                            popperClassName="react-datepicker-popper"
                                        />
                                        <img
                                            src={Images.Calender}
                                            alt="Calender icon"
                                            className="w-4 absolute left-2 top-3 text-gray-500"
                                        />
                                        <MdKeyboardArrowDown
                                            className="absolute right-2 top-3 md:block hidden text-gray-500"
                                            style={{ fontSize: "18px", cursor: "pointer" }}
                                        />
                                    </div>
                                </InputGroup>
                            </ButtonWrapper>
                        </HeaderWrapper>

                        {isDeactivateStaff && (
                            <DeactivateStaff
                                isDeactivateStaff={isDeactivateStaff}
                                setIsDeactivateStaff={setIsDeactivateStaff}
                                deactivateStaffLoading={deactivateStaffLoading}
                                deactivateStaffMutate={deactivateStaffMutate}
                                selectedData={apiData}
                            />
                        )}
                        <SideModal
                            isOpen={isMarkPaidExpense}
                            onClose={() => setIsMarkPaidExpense(false)}
                        >
                            <MarkAsPaidOfflineModal
                                handleClose={() => setIsMarkPaidExpense(false)}
                                markPaidExpenseLoading={markPaidExpenseLoading}
                                markPaidExpenseMutate={markPaidExpenseMutate}
                                selectedData={selectedData}
                                expenseData={expenseData}
                                route="/staff-detail"
                            />
                        </SideModal>

                        <SideModal
                            isOpen={isAddPayable}
                            onClose={() => setIsAddPayable(false)}
                        >
                            <AddPayable
                                handleClose={() => setIsAddPayable(false)}
                                addPayableLoading={addPayableLoading}
                                addPayableMutate={addPayableMutate}
                                staffId={staffDetails?.id}
                            />
                        </SideModal>

                        <SideModal
                            isOpen={isCashRecord}
                            onClose={() => setIsCashRecord(false)}
                        >
                            <CashRecordModal
                                handleClose={() => setIsCashRecord(false)}
                                payToClientMutate={payToClientMutate}
                                payToClientLoading={payToClientLoading}
                                staffId={staffDetails?.id}
                                inhandAmount={inhandCash}
                            />
                        </SideModal>

                        {/* ================= BODY ================= */}
                        <CardBody>
                            <InfoGrid>
                                <InfoItem>
                                    <InfoLabel>Issues Assigned</InfoLabel>
                                    <InfoValue>{apiData?.complaints?.assigned}</InfoValue>
                                </InfoItem>
                                <InfoItem>
                                    <InfoLabel>Issues Solved</InfoLabel>
                                    <InfoValue>
                                        {apiData?.complaints?.closed}
                                    </InfoValue>
                                </InfoItem>

                                <InfoItem>
                                    <InfoLabel>Move Ins</InfoLabel>
                                    <InfoValue>{apiData?.summary?.movedIn}</InfoValue>
                                </InfoItem>

                                <InfoItem>
                                    <InfoLabel>Leads Called</InfoLabel>
                                    <InfoValue>{apiData?.summary?.contacted}</InfoValue>
                                </InfoItem>
                                <InfoItem>
                                    <InfoLabel>Visit Done</InfoLabel>
                                    <InfoValue>{apiData?.summary?.visitDone}</InfoValue>
                                </InfoItem>
                                <InfoItem>
                                    <InfoLabel>Booking</InfoLabel>
                                    <InfoValue>{apiData?.summary?.booked}</InfoValue>
                                </InfoItem>
                            </InfoGrid>
                        </CardBody>
                    </CardContainer>
                    <MainContent>
                        <div className="mx-auto flex justify-between">
                            <TabContainer>
                                <Tab
                                    active={activeTab === "overview"}
                                    onClick={() => setActiveTab("overview")}
                                >
                                    Staff Info
                                </Tab>

                                <Tab
                                    active={activeTab === "payables"}
                                    onClick={() => setActiveTab("payables")}
                                >
                                    Staff Payables
                                </Tab>

                                <Tab
                                    active={activeTab === "ledger"}
                                    onClick={() => setActiveTab("ledger")}
                                >
                                    Ledger
                                </Tab>
                                <Tab
                                    active={activeTab === "bookings"}
                                    onClick={() => setActiveTab("bookings")}
                                >
                                    Bookings
                                </Tab>

                                <Tab
                                    active={activeTab === "documents"}
                                    onClick={() => setActiveTab("documents")}
                                >
                                    Documents
                                </Tab>


                            </TabContainer>
                            <Menu
                                setIsDeactivateStaff={setIsDeactivateStaff}
                                status={apiData?.status}
                            />
                        </div>

                        {/* Tab Content */}
                        <TabContent>
                            {activeTab === "overview" && (
                                <OverviewTab
                                    apiData={apiData}
                                    editStaffMutate={editStaffMutate}
                                    deactivateStaffMutate={deactivateStaffMutate}
                                    editStaffLoading={editStaffLoading}
                                    deactivateStaffLoading={deactivateStaffLoading}
                                    setIsDeactivateStaff={setIsDeactivateStaff}
                                />
                            )}

                            {activeTab === "documents" && (
                                <>
                                    <StaffDocument
                                        docs={docs}
                                        uploadDocMutate={uploadDocMutate}
                                        isDocLoading={isDocLoading}
                                        setIsDocumentAdd={setIsDocumentAdd}
                                        isDocumentAdd={isDocumentAdd}
                                        staffId={staffDetails?.id}
                                    />
                                </>
                            )}

                            {activeTab === "payables" && (
                                <>
                                    <PayableTab
                                        data={payableData?.data}
                                        error={payableListingError}
                                        isLoading={isPayableListingLoading}
                                        isRefetching={isPayableListingRefetching}
                                        setSelectedData={setSelectedData}
                                        setIsMarkPaidExpense={setIsMarkPaidExpense}
                                        setIsAddPayable={setIsAddPayable}
                                    />
                                </>
                            )}

                            {activeTab === "ledger" && (
                                <>
                                    <LedgerTab
                                        data={ledgerData?.data}
                                        error={ledgerListingError}
                                        isLoading={isLedgerListingLoading}
                                        isRefetching={isLedgerRefetching}
                                        isFocused={isFocused}
                                    />
                                </>
                            )}
                            {activeTab === "bookings" && (
                                <>
                                    <CommissionTab
                                        staffId={staffDetails?.id}
                                    />
                                </>
                            )}

                        </TabContent>
                        {showFab && (
                            <FabButton
                                type="button"
                                onClick={() => setIsCashRecord(true)}
                                aria-label="Record Cash"
                                title="Record Cash"
                            >
                                <MdAdd size={24} />
                            </FabButton>
                        )}
                    </MainContent>
                </PageWrapper>
            )}
            {(isLoading || isRefetching) && <TenantDetailsLoading />}
        </BoxContainer>
    );
};

const OverviewTab = ({
    staffDetails,
    editStaffMutate,
    editStaffLoading,
    deactivateStaffLoading,
    deactivateStaffMutate,
    apiData,
    setIsDeactivateStaff
}) => {
    return (
        <Wrapper>
            <BoxHead>
                <TabTitle className="!mb-0 whitespace-nowrap">
                    Staff Details
                    <Underline />
                </TabTitle>
                <div className="text-xs text-gray-500">
                    Created on&nbsp;
                    <span className="font-medium text-gray-700">
                        {moment(apiData?.createdAt).format("MMM DD, YYYY")}
                    </span>
                </div>
            </BoxHead>
            <StaffDetailModal
                editStaffMutate={editStaffMutate}
                deactivateStaffMutate={deactivateStaffMutate}
                editStaffLoading={editStaffLoading}
                deactivateStaffLoading={deactivateStaffLoading}
                selectedData={staffDetails}
                apiData={apiData}
                setIsDeactivateStaff={setIsDeactivateStaff}
            />

        </Wrapper>
    );
};


const PayableTab = ({
    data,
    error,
    isLoading,
    isRefetching,
    setIsMarkPaidExpense,
    setSelectedData,
    setIsAddPayable
}) => {
    return (
        <Wrapper>
            <BoxHead>
                <TabTitle className="!mb-0 whitespace-nowrap">
                    Staff Payables
                    <Underline />
                </TabTitle>
                <AddBtn
                    type="button"
                    onClick={() => setIsAddPayable(true)}
                >
                    Add Payables
                </AddBtn>
            </BoxHead>
            {!error && !isLoading && data?.payables && (
                <TableWrapper>
                    <PayableTable
                        apiData={error ? [] : data?.payables}
                        setIsMarkPaidExpense={setIsMarkPaidExpense}
                        setSelectedData={setSelectedData}
                    />
                    {(error || (data?.payables && data?.payables.length === 0)) && !isLoading && <NotFoundModel />}
                </TableWrapper>)}
            {(isLoading || isRefetching) && <Loading />}
        </Wrapper>
    );
};

const LedgerTab = ({
    data,
    error,
    isLoading,
    isRefetching,
    isFocused
}) => {
    return (
        <Wrapper>
            <BoxHead>
                <TabTitle className="!mb-0 whitespace-nowrap">
                    Ledger
                    <Underline />
                </TabTitle>

            </BoxHead>
            {(isLoading || isRefetching) && !isFocused && (
                <SummarySkeletonLoading count={5} />
            )}
            {isFocused && data &&
                <SummaryCards summaryData={data?.data} />}
            {!error && !isLoading && data?.data?.staffLedger && (
                <TableWrapper>
                    <Table
                        apiData={error ? [] : data?.data?.staffLedger}

                    />
                    {(error || (data?.data?.staffLedger && data?.data?.staffLedger.length === 0)) && !isLoading && <NotFoundModel />}
                </TableWrapper>)}
            {(isLoading || isRefetching) && <Loading />}
        </Wrapper>
    );
};

const CommissionTab = ({
    staffId
}) => {
    return (
        <Wrapper className="!mt-0 !space-y-0">
            <BoxHead className="mt-2">
                <TabTitle className="!mb-0 whitespace-nowrap">
                    Bookings
                    <Underline />
                </TabTitle>
            </BoxHead>
            <StaffDetailCommission staffId={staffId} />
        </Wrapper>
    );
};

const MainContent = tw.div`p-3 rounded-lg bg-white shadow-sm mt-6`;
const TabContainer = tw.div`flex overflow-x-auto gap-6 px-4`;
const Tab = tw.button`relative px-1 py-3 text-sm whitespace-nowrap 
 ${({ active }) =>
        active
            ? "text-zinc-900 font-semibold border-b-2 border-zinc-900"
            : "text-zinc-500 font-normal hover:text-zinc-700"}`;
const TabContent = tw.div`py-6`;
const CardContainer = tw.div`bg-white rounded-xl shadow-sm border border-gray-200/60 overflow-hidden`;
const HeaderWrapper = tw.div`flex items-center justify-between gap-6 p-5 border-b border-gray-100`;
const ProfileWrapper = tw.div`flex items-center gap-4 z-index`;
const TenantInfos = tw.div`flex-1 min-w-0`;
const NameWrapper = tw.div`flex items-center gap-3`;
const TenantName = tw.h2`text-md font-semibold text-gray-900 truncate`;
const TenantProp = tw.p`text-sm text-gray-500 flex-wrap`;
const CardBody = tw.div`p-5`;
const InfoGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6`;
const InfoItem = tw.button``;
const InfoLabel = tw.div`flex items-center gap-2 text-gray-500 text-sm`;
const InfoValue = tw.p`text-base font-semibold text-gray-900 text-left`;
const Wrapper = tw.div`px-4 space-y-4 mt-2`;
const TabTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;
const UserImage = tw.img`w-12 h-12 rounded-full shadow-lg`;
const PageWrapper = tw.div`px-1`;
const AvatarWrapper = tw.div`flex items-center justify-center w-12 h-12`;
const TableWrapper = tw.h1`my-8 border bg-white rounded-md`;
// const AddBtn = tw.button`${(p) =>
//     p.$active ? "bg-gray-100" : ""}
// border whitespace-nowrap border-gray-200 
// flex space-x-1.5 justify-center items-center 
// text-white h-full rounded-md px-6 cursor-pointer 
// bg-primary-color/70 hover:bg-primary-color 
// py-2.5 text-sm
// `;
const AddBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const ButtonWrapper = tw.div`flex flex-col sm:flex-row gap-3 sm:justify-end`;
const FabButton = tw.button`fixed bottom-6 right-8 w-14 h-14 bg-primary-color hover:bg-primary-color/80 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-200 active:scale-95
`;

export default StaffDetail;
